import React from "react"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"
import {
  RegBody,
  SemiBdTitle4,
  IconCheckSolid,
  iconMapper,
  IconName,
  IconChevronRight,
  Button,
} from "@sr/gatsby-theme-ui"

import { Link, Script } from "gatsby"

interface ProductHubListItemProps {
  listProps: {
    body: string
    features: string[]
    product: {
      id: string
      title: string
      path: {
        current: string
      }
      icon: IconName
      hero: {
        on: boolean
        secondaryButtonLinkType: "internal" | "tourial" | "none"
        tourialId: string
      }
      video: {
        url: string
        displayVideo: boolean
      }
    }
  }
}

const ProductHubListItem = ({ listProps }: ProductHubListItemProps) => {
  return (
    <ProductHubListItemStyled>
      <div className="product__container">
        <div>
          <div className="product-list-item__icon-container">
            {iconMapper(listProps?.product?.icon, {
              color: "var(--color-primary)",
            })}
          </div>
          <SemiBdTitle4>
            {listProps?.product?.title ? listProps?.product.title : null}
          </SemiBdTitle4>
          <RegBody className="product-list-item__description">
            {listProps?.body ? listProps?.body : null}
          </RegBody>
          <Link
            to={listProps?.product?.path?.current || ""}
            className="product-learn-more__link"
          >
            <RegBody className="product-learn-more__link-text">
              Learn More
            </RegBody>
            <div className="product-learn-more__link-icon-container">
              <IconChevronRight color="var(--color-primary)" />
            </div>
          </Link>
          {listProps?.features
            ? listProps?.features.map((feature: string, index: number) => {
                return (
                  <div className="product-list-item__feature" key={index}>
                    <IconCheckSolid />
                    <RegBody>{feature}</RegBody>
                  </div>
                )
              })
            : null}
        </div>
        <div className="product__btn-container">
          {listProps?.product?.video?.displayVideo &&
            listProps?.product?.video?.url && (
              <Link
                className="product__btn-link"
                to={`${listProps?.product?.path?.current}#product-video`}
              >
                <Button expand={true}>Watch Video</Button>
              </Link>
            )}
          {listProps?.product?.hero?.secondaryButtonLinkType === "tourial" &&
            listProps?.product?.hero?.tourialId && (
              <a
                href={`https://demos.smartrent.com/pages/${listProps?.product?.hero?.tourialId}`}
                target="_blank"
                className="product__btn-anchor"
              >
                <Button expand>Interactive Tour</Button>
              </a>
              // <>
              //   <Script
              //     type="text/javascript"
              //     src="https://demos.smartrent.com/lightbox.js"
              //     // @ts-ignore
              //     tourialSlug={listProps?.product?.hero?.tourialId}
              //     isMobileVariantEnabled="true"
              //     baseUrlWithSubdomain="https://demos.smartrent.com/"
              //     viewportHeader="false"
              //     id="tourial-lightbox-script"
              //   />

              //   <a
              //     className={`tourial-lightbox-trigger-${listProps?.product?.hero?.tourialId} product__btn-link`}
              //     onClick={() =>
              //       window.Tourial
              //         ? window.Tourial.openLightbox(
              //             "https://demos.smartrent.com/",
              //             listProps?.product?.hero?.tourialId
              //           )
              //         : null
              //     }
              //   >
              //     <Button expand={true}>Take a Tour</Button>
              //   </a>
              // </>
            )}
        </div>
      </div>
    </ProductHubListItemStyled>
  )
}

export default ProductHubListItem

const ProductHubListItemStyled = styled.section`
  .product__container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: ${rem(40)} ${rem(16)};
    justify-content: space-between;
    border: ${rem(1)} solid var(--color-gray300);
    border-radius: ${rem(8)};
    color: var(--color-gray800);

    @media ${media.midUp} {
      padding: ${rem(40)} ${rem(48)};
    }
  }

  .product-list-item__icon-container {
    svg {
      height: ${rem(34)};
      width: ${rem(34)};
      fill: var(--color-primary);
    }
  }

  h4 {
    margin-top: ${rem(8)};
  }

  .product-list-item__description {
    margin-top: ${rem(16)};
  }

  .product-learn-more__link {
    width: ${rem(119)};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: ${rem(8)};
    color: var(--color-primary);
    padding-top: ${rem(8)};
    text-decoration: none;

    @media ${media.midUp} {
      padding-top: ${rem(16)};
    }

    .product-learn-more__link-icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${rem(24)};
      height: ${rem(24)};
      border: 1px solid var(--color-primary);
      border-radius: 50%;
    }
  }
  .product-list-item__feature {
    display: flex;
    gap: ${rem(18)};
    margin-top: ${rem(16)};

    svg {
      min-width: ${rem(20)};
      width: ${rem(20)};
    }

    &:first-child {
      margin-top: ${rem(24)};
    }
  }

  .product__btn-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: ${rem(24)};
    gap: ${rem(16)};

    @media ${media.midUp} {
      flex-direction: row;
      max-width: ${rem(240)};
    }

    .product__btn-link {
      width: 100%;

      @media ${media.midUp} {
        width: ${rem(161)};
      }
    }

    .product__btn-anchor {
      width: 100%;
      color: var(--color-white);
      text-decoration: none;
    }
  }
`
